import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ClientActivityItem, DocumentConditionItem, InspectionItemType } from '../../modules/clientModule/types';

export interface ClientActivitiesState {
  AllPermitsWithActivities: DocumentConditionItem[];
  PermitActivities: ClientActivityItem[];
  SelectedActivityPermit: InspectionItemType;
  activitiesLoading: boolean;
  permitActivitiesLoading: boolean;
}

const initialState: ClientActivitiesState = {
  AllPermitsWithActivities: [],
  PermitActivities: [],
  SelectedActivityPermit: {} as InspectionItemType,
  activitiesLoading: false,
  permitActivitiesLoading: false,
};

export const clientActivitiesSlice = createSlice({
  name: 'clientActivities',
  initialState,
  reducers: {
    setActivities: (state, action: PayloadAction<DocumentConditionItem[]>) => {
      state.AllPermitsWithActivities = action.payload;
      state.activitiesLoading = false;
    },
    setActivitiesLoading: (state, action: PayloadAction<boolean>) => {
      state.activitiesLoading = action.payload;
    },
    setPermitActivities: (state, action: PayloadAction<ClientActivityItem[]>) => {
      state.PermitActivities = action.payload;
      state.permitActivitiesLoading = false;
    },
    setPermitActivitiesLoading: (state, action: PayloadAction<boolean>) => {
      state.permitActivitiesLoading = action.payload;
    },
    setSelectedActivityPermit: (state, action: PayloadAction<InspectionItemType>) => {
      state.SelectedActivityPermit = action.payload;
    },
    resetClientActivities: state => {
      state.AllPermitsWithActivities = [];
      state.PermitActivities = [];
      state.SelectedActivityPermit = {} as InspectionItemType;
    },
  },
});

export const {
  setActivities,
  setActivitiesLoading,
  setPermitActivities,
  setPermitActivitiesLoading,
  setSelectedActivityPermit,
  resetClientActivities,
} = clientActivitiesSlice.actions;

export default clientActivitiesSlice.reducer;
